import clsx from 'clsx';

// Used to trigger sticker replacement [STICKER_TEXT:stickerName]
const STICKER_TEXT = 'sticker';

export default class Stickers {
  constructor() {
    this.icons = window.icons;

    this.replaceIcons();
    this.shopifyListener();
  }

  shopifyListener() {
    document.addEventListener('shopify:section:load', () => {
      this.replaceIcons();
    });
  }

  replaceIcons() {
    const nodeIterator = document.createNodeIterator(
      document.body,
      NodeFilter.SHOW_TEXT,
      (node) =>
        node.textContent.includes(`[${STICKER_TEXT}:`)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    );
    let currentNode;
    // eslint-disable-next-line no-cond-assign
    while ((currentNode = nodeIterator.nextNode())) {
      const tag = currentNode.parentElement;
      const uniqIcons = Array.from(
        new Set(
          Array.from(tag.innerHTML.matchAll(/\[sticker:(.*?)\]/g))
            // eslint-disable-next-line no-unused-vars
            .map(([_, match1]) => match1),
        ).values(),
      );

      uniqIcons.forEach((iconName) => {
        const iconCall = `[${STICKER_TEXT}:${iconName}]`;

        // Add margins on icon if there is a space and letter before or after the icon call
        const charBeforeIconCall = tag.textContent.charAt(
          tag.textContent.indexOf(iconCall) - 1,
        );
        const secondCharBeforeIconCall = tag.textContent.charAt(
          tag.textContent.indexOf(iconCall) - 2,
        );
        const charAfterIconCall = tag.textContent.charAt(
          tag.textContent.indexOf(iconCall) + iconCall.length,
        );
        const secondCharAfterIconCall = tag.textContent.charAt(
          tag.textContent.indexOf(iconCall) + iconCall.length + 1,
        );

        const svgIcon = this.getSVGIcon(
          iconName,
          clsx({
            'ml-2':
              charBeforeIconCall === ' ' &&
              secondCharBeforeIconCall.match(/[a-zA-Z.\s+]/),
            'mr-2':
              charAfterIconCall === ' ' &&
              secondCharAfterIconCall.match(/[a-zA-Z.\s+]/),
          }),
        );

        tag.innerHTML = tag.innerHTML.replaceAll(iconCall, svgIcon);
      });
    }
  }

  getSVGIcon(iconName, className) {
    const icon = this.icons.find((image) => image.name === iconName);

    if (icon) {
      // eslint-disable-next-line max-len
      return `<img src="${icon.image}" alt="${iconName}" class="${className} inline quick-sticker" />`;
    }
    return null;
  }
}
